import ChartCard from './card';
import ChartContainer from './container';
var Chart;
(function (Chart) {
    Chart.Card = ChartCard;
    Chart.Container = ChartContainer;
})(Chart || (Chart = {}));
export default Chart;
